import React from "react";
import { useNavigate } from "react-router-dom";

const BackButton = ({ url, backUrl }) => {
  const navigate = useNavigate();

  const goBack = () => {
    if (url) {
      navigate(url);
    } else {
      navigate(-1); 
    }
  };

  return (
    <button
      type="button"
      className="btn btn-icon btn-outline-success-app mx-2"
      onClick={goBack}
    >
      <span className="tf-icons bx bx-arrow-back"></span>
    </button>
  );
};

export default BackButton;
